import React from "react";
import { TextField, TextArea, CheckboxField } from "../../../common/FormFields";
import InputWithPen from "../../../common/Inputs/InputWithPen";
import ShortDescriptionEditor from "../../../common/RichTextEditor/ShortDescriptionEditor";

/**
 * StepForm Component
 * 
 * Reusable form fields for Step creation/editing
 * 
 * @param {Object} props
 * @param {string} props.mode - "add" or "edit"
 * @param {string} props.versionId - Version ID (for edit mode)
 * @param {boolean} props.isHideStepHeading - Hide step heading checkbox state
 * @param {function} props.onHideStepHeadingChange - Handler for checkbox change
 * @param {string} props.bomTableCategory - BOM table category value
 * @param {function} props.onBomCategoryPencilClick - Handler for BOM category pencil click
 * @param {function} props.onBomCategoryClear - Handler for BOM category clear
 * @param {string} props.partNumberCategory - Part number category value
 * @param {function} props.onPartCategoryPencilClick - Handler for part category pencil click
 * @param {function} props.onPartCategoryClear - Handler for part category clear
 * @param {string} props.shortDescription - Short description value
 * @param {function} props.onShortDescriptionChange - Handler for short description change
 */
const StepForm = ({
  mode = "add",
  versionId = "",
  isHideStepHeading = false,
  onHideStepHeadingChange,
  bomTableCategory = "",
  onBomCategoryPencilClick,
  onBomCategoryClear,
  partNumberCategory = "",
  onPartCategoryPencilClick,
  onPartCategoryClear,
  shortDescription = "",
  onShortDescriptionChange,
  onShortDescriptionDirtyChange,
}) => {
  return (
    <form className="module-form">
      <div className="form-row">
        <div className="full-width">
          <div
            style={{
              display: "flex",
              gap: "10px",
              alignItems: "center",
            }}
          >
            <label
              style={{
                fontWeight: "bold",
                color: "#333",
                marginLeft: "10px",
                marginBottom: "-10px",
              }}
            >
              Version ID (Read Only)
            </label>
            {/* <CheckboxField
              label="Hide Step Heading from Document"
              checked={isHideStepHeading}
              onChange={onHideStepHeadingChange}
              labelStyle={{
                fontWeight: "normal",
                fontSize: "14px",
                marginBottom: "-12px",
              }}
            /> */}
          </div>
          <TextField
            name="id"
            value={mode === "edit" ? versionId : ""}
            disabled={true}
            readOnly={true}
            style={{
              color: mode === "edit" ? "#999999" : "inherit",
            }}
          />
        </div>

        <div className="full-width">
          <InputWithPen
            val={bomTableCategory}
            label={"BOM Table for Step Title"}
            required={true}
            onClickOnPencil={onBomCategoryPencilClick}
            onClear={onBomCategoryClear}
          />
        </div>

        <div className="full-width">
          <InputWithPen
            val={partNumberCategory}
            label={"Item Code Column Title"}
            required={true}
            onClickOnPencil={onPartCategoryPencilClick}
            onClear={onPartCategoryClear}
          />
        </div>
      </div>

      <div className="form-row" style={{ marginTop: "-20px" }}>
        <div className="full-width" style={{ marginLeft: "10px"}}>
          <label
            style={{
              fontWeight: "bold",
              color: "#333",
              marginLeft: "10px",
              marginBottom: "8px",
              display: "block",
            }}
          >
            Short Description
          </label>
          <ShortDescriptionEditor
            value={shortDescription}
            onChange={onShortDescriptionChange}
            onDirtyChange={onShortDescriptionDirtyChange}
            placeholder="Enter Short Description"
            minHeight="100px"
          />
        </div>
      </div>
    </form>
  );
};

export default StepForm;

